const MESSAGE_PARAMS = {
  "internet.activation.days.remaining": (order) => ({
    days: order?.orderInfoRemainingDays,
  }),
  "internet.activation.uncertain": (order) => ({
    phone: order?.orderInfoPhone,
  }),
};

export default function resolveOrderInfoMessage(t, messageKey, order) {
  if (!messageKey) return null;

  if (!messageKey.startsWith("internet.")) return messageKey;

  const i18nKey = messageKey.replace("internet.activation.days.remaining", "internet.activation.days_remaining");
  const getParams = MESSAGE_PARAMS[messageKey];
  const params = getParams ? getParams(order) : {};

  return t(i18nKey, { ns: "common", ...params });
}
